import React from 'react';

/**
 * ImageText 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const ImageTextProperties = [
  {
    group: '이미지-텍스트 설정',
    properties: [
      {
        name: 'componentProps.imageUrl',
        label: '이미지 URL',
        control: 'ImageUploader',
        defaultValue: 'https://via.placeholder.com/400x300'
      },
      {
        name: 'componentProps.imagePosition',
        label: '이미지 위치',
        control: 'Select',
        options: [
          { value: 'left', label: '왼쪽' },
          { value: 'right', label: '오른쪽' }
        ],
        defaultValue: 'left'
      },
      {
        name: 'componentProps.imageWidth',
        label: '이미지 너비',
        control: 'TextField',
        defaultValue: '50%'
      },
      {
        name: 'componentProps.textWidth',
        label: '텍스트 너비',
        control: 'TextField',
        defaultValue: '50%'
      },
      {
        name: 'componentProps.gap',
        label: '간격',
        control: 'TextField',
        defaultValue: '0%'
      },
      {
        name: 'componentProps.verticalAlign',
        label: '세로 정렬',
        control: 'Select',
        options: [
          { value: 'top', label: '상단' },
          { value: 'middle', label: '중앙' },
          { value: 'bottom', label: '하단' }
        ],
        defaultValue: 'middle'
      }
    ]
  },
  {
    group: '두 번째 영역 설정',
    properties: [
      {
        name: 'componentProps.useSecondImage',
        label: '이미지 사용',
        control: 'Checkbox',
        defaultValue: false
      },
      {
        name: 'componentProps.secondImageUrl',
        label: '두 번째 이미지 URL',
        control: 'ImageUploader',
        defaultValue: 'https://via.placeholder.com/400x300',
        condition: {
          property: 'componentProps.useSecondImage',
          value: true
        }
      },
      {
        name: 'content',
        label: 'HTML 내용',
        control: 'RichTextEditor',
        defaultValue: '샘플 텍스트입니다. 내용을 수정해주세요.',
        fullWidth: true,
        condition: {
          property: 'componentProps.useSecondImage',
          value: false
        }
      }
    ]
  },
  {
    group: '스타일 설정',
    properties: [
      {
        name: 'componentProps.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent'
      },
      {
        name: 'componentProps.padding',
        label: '내부 여백',
        control: 'TextField',
        defaultValue: '20px'
      },
      {
        name: 'componentProps.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '0px'
      }
    ]
  }
];

export default ImageTextProperties; 